import {viewError, viewSuccess} from 'src/pages/localChannelLineup/store/selectors/channelTracking';
import {READ_CHANNEL_LINEUP_ERROR, READ_CHANNEL_LINEUP_SUCCESS} from 'src/shared/channelLineup/actions';

export const viewChannelLineup = {
  [READ_CHANNEL_LINEUP_SUCCESS]: viewSuccess,
  [READ_CHANNEL_LINEUP_ERROR]: viewError,
};
